import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core"
import type { ChangeEvent, ReactElement } from "react"
import type { Control, Path } from "react-hook-form"
import { Controller } from "react-hook-form"

type Primitive = boolean | number | string

export interface IRadioGroupFieldProps<T, S> {
  name: Path<T>
  control: Control<T>
  values: { value: Primitive; label: string }[]
  onChange: (value: string) => void
  valueTransformer?: (value: string) => S
}

export function RadioGroupField<T, S>(props: IRadioGroupFieldProps<T, S>): ReactElement {
  const { name, control, values, onChange, valueTransformer } = props

  function onInputChanged(_: ChangeEvent<HTMLInputElement>, value: string): void {
    onChange(value)
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <RadioGroup
          {...field}
          onChange={onInputChanged}
          value={valueTransformer ? valueTransformer(field.value as string) : field.value}
        >
          {values.map(({ value, label }, index: number) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: TODO fix in later PR
            <FormControlLabel key={index} value={value} label={label} control={<Radio color="primary" />} />
          ))}
        </RadioGroup>
      )}
    />
  )
}
